const limitCompaniesValidate = (paymentContract) => {
  const isLimited = paymentContract?.responsibleInLimit ? 0 : 1

  const responsibleInLimitAndCountCompanyInLimit =
    paymentContract?.countCompanyInLimit <=
    paymentContract?.preRegistrationIds?.length - isLimited

  if (paymentContract?.countCompanyInLimit === null)
    return {
      block: true,
      message:
        'Não é possível vincular mais empresas a este contrato, pois o número máximo de empresas permitidas não foi especificado.',
    }

  if (responsibleInLimitAndCountCompanyInLimit) {
    return {
      block: true,
      message:
        'A vinculação de novas empresas a este contrato não é permitida, pois o limite estipulado já foi alcançado.',
    }
  }

  return { block: false }
}

export default limitCompaniesValidate
